import countries from './countries'
import gpc from './gpc'
import lang from './lang'
import uom from './uom'

export default {
  countries,
  gpc,
  lang,
  uom,
  message: {
    my_token: 'API',
    create_new_token: 'Create new token',
    tokens: 'Tokens',
    revocation: 'Revocation',
    username: 'Username',
    comapany_name: 'Company',
    token_id: 'Token Id',
    no_token_found: 'No tokens found',
    loading: 'Loading...',
    token_description_1:
      'With the Verified by GS1 API you have the possibility to automatically retrieve product information from',
    registry_platform: 'the GS1 Registry platform.',
    before_swagger_link: 'The technical documentation can be found',
    token_description_2:
      'Please create tokens on this page, which you can use to access the API.',
    token_description_3: 'here',
    token_tooltip:
      'Here you can create a token to access the Verified by GS1 API.',
    api_docs_tooltip:
      'Technical description of the applicaiton interface for integrating and testing your application.',
    // Modal Token confirm
    modal_confirm_token_title: 'Delete Token',
    modal_confirm_token_text: 'You want to delete token?',
    modal_confirm_token_confirm_button: 'Confirm',
    modal_confirm_token_cancel_button: 'Cancel',
    copy: 'Copy'
  },
  glnType: {
    LEGAL_ENTITY_text: 'Legal Entity',
    FUNCTION_text: 'Function',
    FIXED_PHYSICAL_LOCATION_text: 'Fixed Physical Location',
    MOBILE_PHYSICAL_LOCATION_text: 'Mobile Physical Location',
    DIGITAL_LOCATION_text: 'Digital Location'
  },
  locationIdType: {
    UN_LOCODE_title: 'UN/LOCODE',
    IMO_NUMBER_title: 'International Maritime Organization Number',
    OPEN_LOCATION_CODE_title: 'Open Location Code',
    OAR_ID_title: 'Open Apparel Registry ID',
    UN_LOCODE_tooltip:
      'UN/LOCODE, the United Nations Code for Trade and Transport Locations, is a geographic coding scheme developed and maintained by United Nations Economic Commission for Europe. ',
    IMO_NUMBER_tooltip:
      'IMO number is an important identifier given to oil/gas vessels, shipping vessels, and fishing vessels that is painted visibly across the vessel and bolted to the hull',
    OPEN_LOCATION_CODE_tooltip:
      'The Open Location Code is a geocode system for identifying an area anywhere on the Earth. It was developed at Google\'s Zürich engineering office, and released late October 2014. Location codes created by the OLC system are referred to as "plus codes".',
    OAR_ID_tooltip:
      'Open Apparel Registry ID. A sixteen-digit numbering system which uniquely identities global apparel facilities. The ID consists of a Country code, Origin date (the date the facility first appeared in the registry), a General ID and Check ID. OAR IDs are allocated by the Open Apparel Registry to all facilities contributed to the database for the purposes of enabling industry collaboration and improved identification of factories, as well as powering interoperability between industry databases.'
  },
  organizationIdType: {
    EU_VAT_IDENTIFICATION_NUMBER_title: 'EU VAT Identification Number',
    APE_title: 'Activite Principale Exercee (APE)',
    EORI_title: 'Economic Operators Registration and Identification number',
    PHYTOSANITARY_NUMBER_title: 'Phytosanitary registration number',
    SEC_title: 'U.S. Securities and Exchange Commission',
    CAGE_title: 'Commercial and Government Entity',
    DoDAAC_title: 'Department of Defense Activity Address Code',
    LEI_title: 'Legal Entity Identifier (LEI)',
    APE_NISE_title: 'Activite Principale de l’Entreprise',
    NAF_title: 'Nomenclature des Activités Françaises',
    RCS_title: 'Registre du commerce et des sociétés',
    SIREN_title: "Système d'identification du répertoire des entreprises",
    SIRET_title: "Système d'identification du répertoire des établissements",
    BFA_title: 'Biological Farmers of Australia',
    BIOLAND_title: 'Bioland',
    DEMETER_BUND_title: 'Demeter-Bund',
    DEMETER_INTERNATIONAL_title: 'Demeter International',
    ECOLAND_title: 'Ecoland',
    ECOVIN_title: 'Ecovin',
    EPA_title: 'US Environmental Protection Agency',
    FDA_title: 'FDA US Food and Drug Agency',
    FSA_title: 'UK Food Standards Agency (FSA)',
    GAA_title: 'GAA',
    IFOA_title: 'International Foundation for Organic Agriculture',
    IFOAM_title: 'International Federation of Organic Agriculture Movements.',
    NATURLAND_title: 'Naturland',
    QAI_title: 'Quality Assurance International',
    SUDITIROL_title: 'Sudtirol Bioland',
    USDA_title: 'US Department of Agriculture',
    DUNS_title: 'DUNS',
    DUNS_PLUS_FOUR_title: 'DUNS+4',
    EO_ID_title: 'Economic Operator Identifier',
    EST_NUMBER_title: 'USDA Establishment Number',
    US_EIN_title: 'Employer Identification Number (EIN)',
    US_RSSD_ID_title: 'Replication Server System Database ID (RSSD ID)',
    US_CRD_title: 'Central Registration Depository (CRD) Numbers',
    US_MIC_title: "Manufacturer's Identification Code (MIC)",
    US_UEI_title: 'Unique Entity Identifier (UEI)',
    US_SCAC_title: 'Standard Carrier Alpha Code (SCAC)',
    US_HTS_title: 'Harmonized Tariff Schedule (HTS) Number & Schedule B Codes',
    US_EPA_ID_title: 'EPA Identification Number',
    US_FDIC_title:
      'Federal Deposit Insurance Corporation (FDIC) Certificate Number',
    US_CID_title: 'Company Identifier (CID)',
    US_NPI_title: 'National Provider Identifier (NPI)',
    US_DEA_title: 'Drug Enforcement Administration (DEA) Number',
    US_FEI_title: 'FDA Establishment Identifier (Facility FEI)',
    IFTP_title: 'International Fisheries Trade Permit (IFTP) Number',
    US_MFG_ID_title: 'Manufacturer ID',
    US_FCC_FRN_title: 'FCC Registration Number (FRN)',
    US_499_Filler_ID_title: '499 Filer ID',
    US_498_ID_title:
      'Service Provider and Billed Entity Identification Number (FCC Form 498 ID)',
    US_RN_title: 'Registered Identification Number (RN)',
    IATA_CODE_title: 'International Air Transport Association (IATA) code',
    US_LIC_title: 'Labeler Identification code (LIC)',
    BEA_ID_title: 'BEA Foreign Direct Investment Identification Number',
    FMC_ID_title: 'FMC License Number',
    GIIN_title: 'Global Intermediary Identification Number (GIIN)',
    US_FHFA_ID_title: 'FHFA ID Number',
    US_MINE_ID_title: 'U.S. Mine ID',
    US_LAB_ID_title: 'U.S. Lab ID',
    KVK_NUMBER_title: 'Kamer van Koophandel (KVK) number',
    OIN_NUMBER_title: 'Organisatie-identificatienummer (OIN number)',
    CRN_title: 'Company Registration Number',
    TIN_title: 'Taxpayer Identification Number',
    DID_title: 'Decentralized identifier'
  },
  locationType: {
    ACCOUNTS_DEPARTMENT_title: 'Accounts Department',
    WASTE_CENTER_title: 'Waste Center',
    AGED_CARE_SERVICE_title: 'Aged Care Service',
    WHARF_title: 'Wharf',
    RESEARCH_FACILITY_title: 'Research Facility',
    AIRCRAFT_title: 'Aircraft',
    AIRPORT_title: 'Airport',
    AIRPORT_GATE_title: 'Airport Gate',
    AMBULANCE_SERVICE_title: 'Ambulance Service',
    AMUSEMENT_ENTERTAINMENT_GAMING_title: 'Amusement Entertainment Gaming',
    CASH_CARRY_title: 'Cash and Carry',
    DOCTOR_OFFICE_title: 'Doctor office',
    AREA_HEALTH_title: 'Area Health',
    ASSEMBLY_title: 'Assembly',
    BOTTLING_title: 'Bottling',
    BERTH_title: 'Berth',
    BIRTH_AREA_title: 'Birth Area',
    BOAT_title: 'Boat',
    BANK_title: 'Bank',
    ATM_title: 'ATM',
    CITY_CENTRE_SHOP_title: 'City Centre Shop',
    CLINIC_title: 'Clinic',
    COLLECTION_CENTRE_title: 'Collection Centre',
    CONSOLIDATING_CENTRE_title: 'Consolidating Centre',
    CONSTRUCTION_SITE_title: 'Construction Site',
    CONVENIENCE_STORE_title: 'Convenience Store',
    CORRECTION_FACILITY_title: 'Correction Facility',
    DENTAL_HEALTH_SERVICE_title: 'Dental health service',
    DISTRIBUTION_CENTRE_title: 'Distribution centre',
    DRUG_STORE_title: 'Drugstore',
    DUTY_FREE_STORE_title: 'Duty Free Store',
    EARLY_CHILDHOOD_EDUCATING_AND_CENTRE_title:
      'Early Childhood Education and Centre',
    EDUCATION_FACILITY_title: 'Education Facility',
    EMERGENCY_DEPARTMENT_title: 'Emergency Department',
    FARM_title: 'FARM',
    VINEYARD_title: 'Vineyard',
    FEED_LOT_title: 'Feed Lot',
    FIELD_title: 'Field',
    FOOD_BUSINESS_title: 'Food Business',
    FREIGHT_TERMINAL_title: 'Freight Terminal',
    FREIGHT_HUB_title: 'Freight Hub',
    GARDEN_CENTRE_title: 'Garden Centre',
    GOVERNMENT_DEPARTMENT_AGENCY_title: 'Government Department Agency',
    GREENHOUSE_title: 'Greenhouse',
    HEAD_OFFICE_title: 'Head Office',
    HOSPITAL_title: 'Hospital',
    HOSPITAL_DEPARTMENT_title: 'Hospital Department',
    HOSPITAL_PHARMACY_title: 'Hospital Pharmacy',
    HOSPITAL_CAFETERIA_title: 'Hospital Cafeteria',
    IMAGING_DIAGNOSTICS_title: 'Imaging Diagnostics',
    IMPREST_LOCATION_title: 'Imprest Location',
    INLAND_FISHERY_title: 'Inland Fishery',
    INBOUND_AND_OUTBOUND_DOCK_title: 'Inbound And Outbound Dock',
    INBOUND_DOCK_title: 'Inbound Dock',
    INTERMODAL_TERMINAL_title: 'Intermodal Terminal',
    LIBRARY_title: 'Library',
    LANE_OR_ROUTE_title: 'Lane or route',
    MAIN_RECEPTION_title: 'Main Reception',
    MANUFACTURING_PLANT_title: 'Manufacturing Plant',
    MARINE_FISHERY_title: 'Marine Fishery',
    MARKET_title: 'Market',
    MENTAL_HEALTH_SERVICE_title: 'Mental Health Service',
    MILKING_SITE_title: 'Milking Site',
    NURSE_STATION_title: 'Nurse Station',
    OFFICE_title: 'Office',
    OPERATING_THEATRE_title: 'Operating Theatre',
    OUTBOUND_DOCK_title: 'Outbound Dock',
    PACKHOUSE_title: 'Packhouse',
    PATHOLOGY_title: 'Pathology',
    PERSONAL_SERVICES_title: 'Personal Services',
    PETROL_STATION_title: 'Petrol Station',
    RETAIL_PHARMACY_title: 'Retail Pharmacy',
    POINT_OF_SALE_title: 'Point Of Sale',
    PRIMARY_HEALTH_SERVICE_title: 'Primary Health Service',
    PRODUCTION_LINE_title: 'Production Line',
    PUBLIC_WAREHOUSE_title: 'Public Warehouse',
    RAIL_STATION_title: 'Rail Station',
    REARING_AREA_title: 'Rearing Area',
    REPACKER_title: 'Repacker',
    RESIDENCE_title: 'Residence',
    RETAIL_OUTLET_title: 'Retail Outlet',
    RETURNABLE_ASSET_SERVICE_CENTRE_title: 'Returnable Asset Service Centre',
    SEAPORT_title: 'Seaport',
    SELF_SERVICE_title: 'Self Service',
    SERVICE_COUNTER_title: 'Service Counter',
    SILO_title: 'Silo',
    SLAUGHTER_HOUSE_title: 'Slaughterhouse',
    SPORTS_AND_RECERATIONAL_title: 'Sports and Recreational',
    STATION_title: 'Station',
    STOCKING_LOCATION_title: 'Stocking location',
    STORAGE_LOCATION_title: 'Storage Location',
    STORE_title: 'Store',
    TERMINAL_title: 'Terminal',
    TRADE_ITEM_RETURN_LOCATION_title: 'Trade Item Return Location',
    TRAIN_title: 'Train',
    VENDING_title: 'Vending',
    VENDOR_LEASED_SPACE_title: 'Vendor Leased Space',
    VISITING_ADDRESS_title: 'Visiting Address',
    WARD_title: 'Ward',
    WAREHOUSE_AND_OR_DEPOT_title: 'Warehouse and/or Depot',
    SALES_YARD_title: 'Sales Yard',
    RECEIVING_LOCATION_title: 'Receiving Location',
    BACKROOM_title: 'Backroom',
    STORAGE_AREA_title: 'Storage Area',
    SALES_FLOOR_title: 'Sales Floor',
    RETURNS_AREA_title: 'Returns Area',
    PRODUCTION_AREA_title: 'Production Area',
    RECEIVING_AREA_title: 'Receiving Area',
    SHIPPING_AREA_title: 'Shipping Area',
    SALES_FLOOR_TRANSITION_AREA_title: 'Sales Floor Transition Area',
    CUSTOMER_PICK_UP_AREA_title: 'Customer Pick-Up Area',
    YARD_title: 'Yard',
    CONTAINER_DECK_title: 'Container Deck',
    CARGO_TERMINAL_title: 'Cargo Terminal',
    PACKAGING_AREA_title: 'Packaging Area',
    PICKING_AREA_title: 'Picking Area',
    ELECTRONICS_AREA_title: 'Electronics Area',
    SHELF_title: 'Shelf',
    PROMOTION_AREA_title: 'Promotion Area',
    END_CAP_AREA_title: 'End Cap Area',
    SECURITY_AREA_title: 'Security Area',
    GENERAL_MDSE_AREA_title: 'General Merchandise Area',
    GROCERY_title: 'Grocery',
    BOX_CRUSHER_title: 'Box Crusher',
    CONVEYOR_BELT_title: 'Conveyor Belt',
    PALLET_WRAPPER_title: 'Pallet Wrapper',
    FIXED_READER_title: 'Fixed Reader',
    MOBILE_READER_title: 'Mobile Reader',
    STAGING_title: 'Staging',
    LAY_AWAY_title: 'Lay-Away',
    DISPENSER_title: 'Dispenser',
    QUARANTINE_title: 'Quarantine',
    CONTROLLED_SUBSTANCE_AREA_title: 'Controlled Substance Area',
    RECALLED_PRODUCT_AREA_title: 'Recalled Product  Area',
    QUALITY_CONTROL_title: 'Quality Control',
    PRINTING_ROOM_title: 'Printing Room',
    ENTRANCE_GATE_title: 'Entrance Gate',
    EXIT_GATE_title: 'Exit Gate',
    GATE_title: 'Gate',
    READ_POINT_VERIFICATION_SPOT_title: 'Read Point Verification Spot',
    // org title
    ACCEPTING_PARTY_title: 'Accepting Organization',
    BILL_OF_LADING_RECIPIENT_title: 'Bill of Lading Recipient',
    BILL_TO_title: 'Bill To',
    BRAND_OWNER_title: 'Brand Owner',
    BREEDER_title: 'Breeder',
    BROKER_AGENT_title: 'Broker Agent',
    BUYER_title: 'Buyer',
    BUYERS_AGENT_REPRESENTATIVE_title: 'Buyers Agent Representative',
    CARRIER_title: 'Carrier',
    CLINICAL_TRIAL_SPONSOR_title: 'Clinical trial sponsor',
    CENTRAL_PAYMENT_SERVICE_title: 'Central Payment Service',
    CHECKING_PARTY_title: 'Checking Organization',
    CHEQUE_ORDER_title: 'Cheque Order',
    CONSIGNEE_title: 'Consignee',
    CONSIGNOR_title: 'Consignor',
    CONSUMER_title: 'Consumer',
    CONSOLIDATOR_title: 'Consolidator',
    CORPORATE_IDENTITY_title: 'Corporate Identity',
    CUSTOMS_title: 'Customs',
    RECALL_RECIPIENT_title: 'Recall Recipient',
    RECALL_SPONSOR_title: 'Recall Sponsor',
    CUSTOMS_BROKER_title: 'Customs Broker',
    CUTTER_title: 'Cutter',
    DECLARANTS_AGENT_REPRESENTATIVE_title: 'Declarants Agent Representative',
    DELIVERY_PARTY_title: 'Delivery Organization',
    DESIGNER_title: 'Designer',
    DESPATCH_PARTY_title: 'Despatch Organization',
    DISTRIBUTOR_title: 'Distributor',
    DOCK_DOOR_title: 'Dock Door',
    EMPTY_EQUIPMENT_DESPATCH_PARTY_title:
      'Empty Equipment Despatch Organization',
    EMPTY_EQUIPMENT_RETURN_PARTY_title: 'Empty Equipment Return Organization',
    EQUIPMENT_OWNER_title: 'Equipment Owner',
    EXPORTER_title: 'Exporter',
    FACTOR_title: 'Factor',
    FATTENER_title: 'Fattener',
    FREIGHT_FORWARDER_title: 'Freight Forwarder',
    GOODS_OWNER_title: 'Goods Owner',
    GROWER_title: 'Grower',
    HEALTHCARE_PROVIDER_title: 'Healthcare Provider',
    IMPORTER_title: 'Importer',
    INFORMATION_PROVIDER_title: 'Information Provider',
    INSURER_title: 'Insurer',
    INTERMEDIARY_BANK_title: 'Intermediary Bank',
    RETAILER_title: 'Retailer',
    MARKETPLACE_OPERATOR_title: 'Marketplace Operator',
    FOODSERVICE_OPERATOR_title: 'Foodservice Operator',
    FOODSERVICE_DISTRIBUTOR_title: 'Foodservice distributor',
    PHARMACY_OPERATOR_title: 'Pharmacy Operator',
    FARM_OPERATOR_title: 'Farm Operator',
    HARVESTER_title: 'Harvester',
    FISHING_OPERATOR_title: 'Fishing Operator',
    INVENTORY_CONTROLLER_title: 'Inventory Controller',
    INVENTORY_REPORTING_PARTY_title: 'Inventory Reporting Organization',
    INVOICEE_title: 'Invoicee',
    ISSUER_OF_INVOICE_title: 'Issuer of Invoice',
    LOGISTICS_SERVICE_PROVIDER_title: 'Logistics Service Provider',
    MANUFACTURER_OF_GOODS_title: 'Manufacturer of Goods',
    MARK_FOR_title: 'Mark For',
    MESSAGE_FROM_title: 'Message From',
    MESSAGE_RECIPIENT_title: 'Message Recipient',
    MINCER_title: 'Mincer',
    OPERATING_DIVISION_title: 'Operating Division',
    OPERATOR_title: 'Operator',
    ORDERING_PARTY_title: 'Ordering Organization',
    OWNER_OF_EQUIPMENT_title: 'Owner of equipment',
    OWNER_OF_MEANS_OF_TRANSPORT_title: 'Owner of Means of Transport',
    PARTY_DECLARING_THE_VALUE_ADDED_TAX_title:
      'Organization Declaring the Value Added Tax',
    PARTY_FOR_WHOM_ITEM_IS_ULTIMATELY_INTENDED_title:
      'Organization For Whom Item is Ultimately Intended',
    PARTY_RECEIVING_PRIVATE_DATA_title: 'Organization Receiving Private Data',
    PARTY_RECOVERING_THE_VALUE_ADDED_TAX_title:
      'Organization Recovering the Value Added Tax',
    PARTY_TO_RECEIVE_ALL_DOCUMENTS_title:
      'Organization to Receive All Documents',
    PARTY_TO_RECEIVE_COMMERCIAL_INVOICE_title:
      'Organization to Receive Commercial Invoice',
    PARTY_TO_RECEIVE_ELECTRONIC_MEMO_OF_INVOICE_title:
      'Organization to Receive Electronic Memo of Invoice',
    PARTY_TO_RECEIVE_FREIGHT_BILL_title: 'Organization to Receive Freight Bill',
    PARTY_TO_RECEIVE_REFUND_title: 'Organization to Receive Refund',
    PAYEE_title: 'Payee',
    PAYER_title: 'Payer',
    PRICE_LOCATION_PARTY_title: 'Price Location Organization',
    PROXY_title: 'Proxy',
    PURCHASE_ORDER_RECEIVER_title: 'Purchase Order Receiver',
    PACKER_title: 'Packer',
    TRADER_title: 'Trader',
    REGISTERED_AGENT_title: 'Registered Agent',
    REMIT_TO_title: 'Remit to',
    SELLER_title: 'Seller',
    SERVICE_PROVIDER_title: 'Service Provider',
    SLAUGHTERER_title: 'Slaughterer',
    E_TAILER_title: 'E-tailer',
    STORAGE_AND_HANDLING_title: 'Storage and Handling',
    AGRICULTURAL_COOPERATIVE_title: 'Agricultural Cooperative',
    CASH_TRANSPORT_SERVICES_title: 'Cash Transport Services',
    SUBSTITUTE_SUPPLIER_title: 'Substitute Supplier',
    SUPPLIER_title: 'Supplier',
    TRANSPORTATION_CARRIER_title: 'Transportation Carrier',
    WAREHOUSE_KEEPER_title: 'Warehouse Keeper',
    WHOLESALER_title: 'Wholesaler',
    SHIP_FROM_title: 'Ship From',
    SHIP_TO_title: 'Ship To'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/index.js